<template>
  <div class="kefu_competemy">
    <van-popup v-model="myshow">
      <div class="kefu_box ">
        <van-image width="3.73rem" height="3.73rem" style="margin-top:2rem"
                   src="https://hxxxkj-oss-cdn.xiaoyi120.com/wholesale-H5/kefu_urcode.png"
        />
        <div class="kefu_title">长按识别二维码 ，添加客服微信</div>

        <div class="kefu_btn flex-r-sa-c">
          <div class="x" />
          <div class="kefu_btn_phone flex-r-c-c" @click="phone">
            <van-icon name="phone" size="0.5rem" /><span>电话咨询</span>
          </div>
          <div class="kefu_btn_online flex-r-c-c" @click="online">
            <van-icon name="comment" size="0.5rem" /><span>在线沟通</span>
          </div>
          <div class="x" />
        </div>
        <!-- <div class="kefu_btn2" @click="phone"> 拨打客服电话 </div> -->
        <van-image width="0.69rem" height="0.69rem" style="margin-top:1.28rem"
                   src="https://hxxxkj-oss-cdn.xiaoyi120.com/wholesale-H5/kefu_close.png" @click="myshow = false"
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'KefuBtn',
  props: {
    show: { type: Boolean, default: false }
  },
  data() {
    return {
      myshow: this.show,
      phoneNumber: '025-86210116'
    }
  },
  methods: {
    changeShow(isshow) { this.myshow = isshow },
    phone() { window.location.href = 'tel://' + this.phoneNumber },
    online() { window.location.href = 'https://work.weixin.qq.com/kfid/kfcf37c7313101d7a75' }
  }
}
</script>

<style lang="scss" scoped>
.kefu_competemy {
  .van-popup {
    border-radius: 0.27rem;
    background: none;

    width: 7.47rem;
    height: 10.7rem;
  }
  .kefu_box {
    width: 7.47rem;
    height: 10.7rem;
    // background: linear-gradient(180deg, #d4e9fa 0%, #ffffff 100%);
    background-image: url("https://hxxxkj-oss-cdn.xiaoyi120.com/wholesale-H5/kefu_bg.png");
    background-size: 7.47rem 9.07rem;
    background-repeat: no-repeat;

    .kefu_title {
      font-size: 0.35rem;
      line-height: 0.48rem;
      text-align: center;
      color: #333;

      margin-top: 0.32rem;
    }
    .kefu_time {
      font-size: 0.37rem;
      color: #999999;
      margin-bottom: 2rem;
    }
    .kefu_btn {
      // position: absolute;
      width: 100%;
      height: 1.76rem;
      .kefu_btn_phone {
        width: 3rem;
        height: 1rem;
        line-height: 1rem;
        border-radius: 0.53rem;
        background: linear-gradient(180deg, #34a2f0 0%, #0d81d4 100%);
        border: 0.03rem solid #d8ebff;

        font-size: 0.37rem;
        text-align: center;
        color: #fff;
      }
      .kefu_btn_online {
        width: 3rem;
        height: 1rem;
        line-height: 1rem;
        border-radius: 0.53rem;
        background: linear-gradient(180deg, #34a2f0 0%, #0d81d4 100%);
        border: 0.03rem solid #d8ebff;

        font-size: 0.37rem;
        text-align: center;
        color: #fff;
      }
      span {
        margin-left: 0.1rem;
      }
    }
    .kefu_btn2 {
      width: 6.19rem;
      height: 1.07rem;
      line-height: 1.07rem;
      border-radius: 0.53rem;
      background: linear-gradient(180deg, #34a2f0 0%, #0d81d4 100%);
      border: 0.03rem solid #d8ebff;

      font-size: 0.37rem;
      text-align: center;
      color: #fff;

      margin-top: 0.37rem;
      margin-left: 0.64rem;
    }
  }
}
</style>
